import React from "react";
import styled from "styled-components";
import { RotateRightOutlined, RotateLeftOutlined } from "@ant-design/icons";
import { ControllerContainer } from "./ImageReview.styles";

const rotationProperties = {
    cursor: 'pointer',
    fontSize: '2rem',
    color: 'black'
};

const RotateLeft = styled(RotateLeftOutlined)(rotationProperties);
const RotateRight = styled(RotateRightOutlined)(rotationProperties);

export const ImageControls = ({ setRotation }) => {
    const onRotateLeft = () => setRotation((prev) => prev - 90);
    const onRotateRight = () => setRotation((prev) => prev + 90);

    return (
        <ControllerContainer>
            <RotateLeft onClick={ onRotateLeft }/>
            <RotateRight onClick={ onRotateRight }/>
        </ControllerContainer>
    );
};